<script setup>
import { useDetectDevice } from '@/composables/device'

import StaffsView from '@/components/planner/StaffsView.vue'
import StaffsGrid from '@/components/planner/StaffsGrid.vue'

const { isMobile } = useDetectDevice()

</script>
<template>
  <staffs-view v-if="isMobile" />
  <staffs-grid v-else />
</template>
